import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const DocTypeIcon = ({ type, className = "text-2xl" }) => {
  const icons = {
    will: FiIcons.FiFileText,
    trust: FiIcons.FiShield,
    immigration_poa: FiIcons.FiGlobe
  };

  const colors = {
    will: 'text-blue-600',
    trust: 'text-emerald-600',
    immigration_poa: 'text-amber-600'
  };

  return (
    <div className={`p-3 rounded-lg bg-slate-50 ${colors[type] || 'text-slate-600'}`}>
      <SafeIcon icon={icons[type] || FiIcons.FiFile} className={className} />
    </div>
  );
};